var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-danger"},[_c('ul',{staticClass:"list-unstyled pt-1"},_vm._l((_vm.errors),function(e,idx){return _c('li',{key:idx,staticStyle:{"font-size":"13px"}},[_vm._v(" "+_vm._s(e)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }